
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.003 7.643c.188-.394.574-.644.997-.644.423 0 .81.25.997.644l.684 1.442c.162.34.475.577.837.632l1.53.231c.419.063.767.368.898.786.13.418.021.877-.281 1.184l-1.108 1.124a1.184 1.184 0 00-.32 1.022l.262 1.584c.071.434-.1.872-.442 1.13a1.076 1.076 0 01-1.17.088l-1.37-.748a1.074 1.074 0 00-1.034 0l-1.37.748c-.374.205-.827.17-1.17-.088a1.177 1.177 0 01-.442-1.13l.262-1.584a1.184 1.184 0 00-.32-1.022l-1.108-1.123a1.187 1.187 0 01-.28-1.185c.13-.418.478-.723.897-.786l1.53-.231c.362-.055.675-.291.837-.632l.684-1.442z","fill":"#D07D01"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9.004","stroke":"#CACACA","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    